var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitFarmerBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#79C9DB;}\n\t.st1{fill:#99DBFF;}\n\t.st2{fill:#6B3E35;}\n\t.st3{fill:#00B379;}\n\t.st4{fill:#72D473;}\n\t.st5{fill:#258C64;}\n\t.st6{fill:#00A36D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400,
    cy: 400,
    r: 399.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400,800C206.2,800.2,35.8,659.3,4.9,461.9C-29.3,243.6,119.9,39,338.1,4.9C358.9,1.6,379.6,0,400,0V800z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.7,400c-12.6,0-22.7-10.2-22.7-22.7v-78.4c0-12.5,10.2-22.7,22.7-22.7s22.7,10.2,22.7,22.7v78.4 C667.4,389.9,657.2,400,644.7,400z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M710.9,381.8c-12.6,0-22.7-10.2-22.7-22.7v-84c0-12.5,10.2-22.7,22.7-22.7s22.7,10.2,22.7,22.7v84 C733.6,371.6,723.4,381.8,710.9,381.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.1,674.5c87.5,92.5,217.5,141.8,352.8,120.6C680.1,761,829.3,556.4,795.1,338.2 C455.4,332.4,220,545.6,109.1,674.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.3,383.8c-1,25.6,0.4,51.8,4.5,78.1c34.2,218.2,238.8,367.4,457,333.3c170.5-26.7,298.8-157.4,330.6-317.4 C719.8,439.8,446.6,319.5,0.3,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.3,383.8c-1,25.6,0.4,51.8,4.5,78.1c34.2,218.2,238.8,367.4,457,333.3c170.5-26.7,298.8-157.4,330.6-317.4 C719.8,439.8,446.6,319.5,0.3,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.3,383.8c-1,25.6,0.4,51.8,4.5,78.1C35.8,659.3,206.2,800.2,400,800V372.3 C288.2,361.4,154.6,361.6,0.3,383.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9,483.8C53,690,251.1,828.1,461.9,795.1C591.4,774.8,696.6,694.5,753.5,587C691,553.4,434.1,434.6,9,483.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9,483.8C48.6,669.7,213.5,800.2,400,800V484l-3.8-0.5C289,470,159.5,466.4,9,483.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.4,583.2c76.8,149,242.7,239.2,417.5,211.9c88-13.8,164.7-55.3,222.7-114.1 C599.3,640.6,380.8,559.1,44.4,583.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.4,583.2C112,714.6,248.9,800.2,400,800V597.1l-2.4-0.4C300.4,581.2,182.3,573.4,44.4,583.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M461.9,795.1c39.1-6.1,76-17.8,110-33.9c-94.3-34.1-249-75.4-451.7-75.5C207.3,770.9,332.2,815.4,461.9,795.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,713.4c-78.6-16-172.5-27.6-279.9-27.7c73.2,71.6,173,114.4,279.9,114.3V713.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitFarmerBadge);
export default __webpack_public_path__ + "static/media/bit_farmer_badge.e88dbffe7abdf51e751b31aaaa45d3ab.svg";
export { ForwardRef as ReactComponent };